import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

type Props = {
  show: boolean;
  onHide: () => void;
  goBack?: boolean;
  ClustDoc?: boolean;
  redirectURL?: string;
};

export default function NautilusAsset({
  show,
  onHide,
  goBack = false,
  ClustDoc = false,
  redirectURL = "",
}: Props) {
  const { t } = useTranslation(["common", "components"]);
  const navigate = useNavigate();

  const handleGoBack = () => {
    onHide();
    if (goBack) {
      navigate(-1);
    }
  };

  const onHandleNautilusAsset = () => {
    window.open(redirectURL, "_blank");
  };
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Body className="text-center d-flex flex-column align-items-center p-5">
        <p className="mb-4">
          {t(ClustDoc ? "nautilusAsset.clust_doc" : "nautilusAsset.message", {
            ns: "components",
          })}
        </p>
        <div className="d-flex justify-content-center align-items-center">
          <button
            className="modal-primary-button modal-secondary-button me-4"
            onClick={handleGoBack}
          >
            {t("button.go_back", { ns: "common" })}
          </button>
          <button
            className="modal-primary-button"
            onClick={onHandleNautilusAsset}
          >
            {t("button.proceed", { ns: "common" })}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
